var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPurchaseOutline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 22,
    viewBox: "0 0 28 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.6667 0.333313H3.33335C1.85335 0.333313 0.68002 1.51998 0.68002 2.99998L0.666687 19C0.666687 20.48 1.85335 21.6666 3.33335 21.6666H24.6667C26.1467 21.6666 27.3334 20.48 27.3334 19V2.99998C27.3334 1.51998 26.1467 0.333313 24.6667 0.333313ZM24.6667 19H3.33335V11H24.6667V19ZM3.33335 5.66665H24.6667V2.99998H3.33335V5.66665Z",
    fill: "#0029F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurchaseOutline);
export default __webpack_public_path__ + "static/media/PurchaseOutline.6a1012cd533129f3cb17d36452aefcf4.svg";
export { ForwardRef as ReactComponent };